// Título de la pestaña por ruta: "LGR - <sección>". Reusa el catálogo del menú
// (SECTIONS) para no duplicar labels; suma las rutas que no están en el menú
// (dashboard, login, portales públicos). Match por prefijo más largo, así un
// detalle (/notas-venta/123, /notas-venta/nueva) hereda el título de su listado.
import { SECTIONS } from '../components/Layout'

// Rutas fuera del menú lateral.
const EXTRA = {
  '/dashboard': 'Inicio',
  '/login': 'Ingresar',
  '/portal': 'Portal del cliente',
  '/seguimiento': 'Seguimiento de envío',
  '/fletero': 'Reparto',
  '/entrevista': 'Entrevista',
  '/rrhh/sueadic': 'SueAdic',
  '/configuracion': 'Sistema',
  '/seguridad': 'Seguridad',
}

// Aplana items + subsecciones de SECTIONS a una lista {path, label}.
function aplanar(items, acc = []) {
  for (const it of items || []) {
    if (it.path) acc.push({ path: it.path, label: it.label })
    if (it.items) aplanar(it.items, acc)
  }
  return acc
}

const MAPA = [
  ...SECTIONS.flatMap((s) => aplanar(s.items)),
  ...Object.entries(EXTRA).map(([path, label]) => ({ path, label })),
].sort((a, b) => b.path.length - a.path.length) // prefijo más largo primero

const PREFIJO_ENV = (typeof window !== 'undefined' && window.location.hostname.startsWith('dev.')) ? 'DEV · ' : ''

function tituloDeRutaBase(pathname) {
  const m = MAPA.find((e) => pathname === e.path || pathname.startsWith(e.path + '/'))
  return m ? `LGR - ${m.label}` : 'LGR'
}


export function tituloDeRuta(pathname) {
  return PREFIJO_ENV + tituloDeRutaBase(pathname)
}
